import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route, NavLink, Redirect } from 'react-router-dom';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import Permit from './Permit';
import CreatePermit from './CreatePermit';
import UpdatePermit from './UpdatePermit';

function TemplatesContainer({ match }) {
  const permissions = getJson('permissions');

  return (
    <div
      className="d-flex flex-column"
      style={{
        height: '100svh',
        padding: '94px 15px 15px 15px',
        marginTop: '-79px',
        // overflowY: 'hidden',
      }}
    >
      <div className="module-inner-title">Templates</div>
      <div className="generic-module-nav mb-3">
        {Acl(permissions, ['VIEW TEMPLATE BUSINESS PERMITS']) && (
          <NavLink
            // exact
            className="nav-link"
            activeClassName="active"
            to="/general-settings/templates/business-permit"
          >
            Business Permit Templates
          </NavLink>
        )}
        {Acl(permissions, ['VIEW TEMPLATE OFFICIAL RECEIPTS']) && (
          <NavLink
            exact={false}
            className="nav-link"
            activeClassName="active"
            to="/general-settings/templates/official-receipt"
          >
            Official Receipt Templates
          </NavLink>
        )}
        {Acl(permissions, ['VIEW TEMPLATE STATEMENT OF ACCOUNTS']) && (
          <NavLink
            exact={false}
            className="nav-link"
            activeClassName="active"
            to="/general-settings/templates/soa"
          >
            Statement of Account Templates
          </NavLink>
        )}
        {Acl(permissions, ['VIEW TEMPLATE BARANGAY BUSINESS CLEARANCES']) && (
          <NavLink
            exact={false}
            className="nav-link"
            activeClassName="active"
            to="/general-settings/templates/barangay-clearance"
          >
            Barangay Business Clearance Templates
          </NavLink>
        )}
        {Acl(permissions, ['VIEW TEMPLATE RETIREMENT TEMPLATES']) && (
          <NavLink
            exact={false}
            className="nav-link"
            activeClassName="active"
            to="/general-settings/templates/retirement-templates"
          >
            Retirement Templates
          </NavLink>
        )}
      </div>

      <Switch>
        {Acl(permissions, ['VIEW TEMPLATE BUSINESS PERMITS']) && (
          <Route
            exact
            path="/general-settings/templates"
            render={() => (
              <Redirect to="/general-settings/templates/business-permit" />
            )}
          />
        )}
        <Route path={`${match.path}/:permit/create`} component={CreatePermit} />
        <Route
          path={`${match.path}/:permit/update/:id`}
          component={UpdatePermit}
        />
        <Route path={`${match.path}/:permit`} component={Permit} />
      </Switch>
    </div>
  );
}

TemplatesContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
};

export default TemplatesContainer;
